import { createSlice } from '@reduxjs/toolkit';
import { companyApiSlice } from './companyApiSlice';

const initialState = {
    companies: [],
    companiesByRuc: {},
};

const companySlice = createSlice({
    name: 'companies',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            companyApiSlice.endpoints.getPublicCompanies.matchFulfilled,
            (state, { payload }) => {
                state.companies = payload;
                state.companiesByRuc = payload.reduce((acc, company) => {
                    acc[company.ruc] = company;
                    return acc;
                }, {});
            }
        );
    },
});

export default companySlice.reducer;
